import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

const nestedStartNode = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'nestedNode',
      nestedNode: {
        targetFlowName: '',
        inputVars: {
          '': '',
        },
      },
    },
    type: 'integration',
    next: newStepValue,
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.nestedNode.targetFlowName',
    'next',
    'integration.nestedNode.inputVars.#',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.nestedNode.targetFlowName',
        'next',
      ],
    },
    {
      Logic: ['integration.nestedNode.inputVars.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    targetFlowName: {
      type: 'text',
      label: 'Target Flow Name',
      validators: {
        required: true,
      },
    },
    next: {
      type: 'next',
      label: 'Point to',
    },
    inputVars: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
        class: 'keyValuePairRow',
      },
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: false,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: false,
        },
      },
    },
  },
  data: {
    inputVars: {
      '': '',
    },
  },
};

export const nestedNode: {} = {
  nestedNode: nestedStartNode,
};
